import type { Skill } from 'bundles/browse/components/Domain/types/Domain';

import _t from 'i18n!nls/browse';

export const TOTAL_NUMBER_OF_SKILLS_TO_SHOW = 12;

// optimized version of DomainTopSkills.tsx
// we can remove some domains since we're showing domainTopSkills if that exists
// limit to 12 skills per domain since we're only showing 12 max
// also it makes more sense to show skills with tag > 0

const getDomainSkillsData = (): Array<Skill> => {
  return [
    {
      domainId: 'information-technology',
      skillId: 'google',
      skillName: _t('Google'),
      numberOfTaggedCourses: 50,
      skillSearchUrl: '/courses?query=google',
    },
    {
      domainId: 'information-technology',
      skillId: 'google-cloud-platform',
      skillName: _t('Google Cloud Platform'),
      numberOfTaggedCourses: 38,
      skillSearchUrl: '/courses?query=google%20cloud%20platform',
    },
    {
      domainId: 'information-technology',
      skillId: 'computer-security',
      skillName: _t('Cybersecurity'),
      numberOfTaggedCourses: 21,
      skillSearchUrl: '/courses?query=cybersecurity',
    },
    {
      domainId: 'information-technology',
      skillId: 'application-programming-interfaces',
      skillName: _t('Application programming interfaces'),
      numberOfTaggedCourses: 17,
      skillSearchUrl: '/courses?query=api',
    },
    {
      domainId: 'information-technology',
      skillId: 'internet',
      skillName: _t('Internet'),
      numberOfTaggedCourses: 15,
      skillSearchUrl: '/courses?query=internet',
    },
    {
      domainId: 'information-technology',
      skillId: 'linux',
      skillName: _t('Linux'),
      numberOfTaggedCourses: 15,
      skillSearchUrl: '/courses?query=linux',
    },
    {
      domainId: 'information-technology',
      skillId: 'kubernetes',
      skillName: _t('Kubernetes'),
      numberOfTaggedCourses: 14,
      skillSearchUrl: '/courses?query=kubernetes',
    },
    {
      domainId: 'information-technology',
      skillId: 'computer-programming',
      skillName: _t('Computer Programming'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=computer%20programming',
    },
    {
      domainId: 'information-technology',
      skillId: 'computer-network',
      skillName: _t('Computer Network'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=computer%20network',
    },
    {
      domainId: 'information-technology',
      skillId: 'software-testing',
      skillName: _t('Software Testing'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=software%20testing',
    },
    {
      domainId: 'information-technology',
      skillId: 'internet-of-things',
      skillName: _t('Internet of things'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=internet%20of%20things',
    },
    {
      domainId: 'information-technology',
      skillId: 'network-security',
      skillName: _t('Network security'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=network%20security',
    },
  ];
};

export default getDomainSkillsData;
